import Status from "@/components/tag/Status";
import { TableComponent } from "@/layouts/table/TableLayout";
import { IUserDataProps } from "@/types/interfaces";
import { Box, Text } from "@chakra-ui/react";
import moment from "moment";
import { useMemo } from "react";
import { Link } from "react-router-dom";

const Claims = ({ data }: IUserDataProps) => {
	const columns = useMemo(
		() => [
			{
				Header: "Date",
				accessor: "date",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Type of incident",
				accessor: "typeOfIncident",
			},
			{
				Header: "Status",
				accessor: "status",
				Cell: ({ value }: { value: string }) => {
					return (
						<Box>
							<Status text={value === "PENDING" ? "Pending" : "Approved"} />
						</Box>
					);
				},
			},
			{
				Header: "",
				accessor: "action",
				Cell: ({ value }: { value: string }) => {
					return (
						<Box>
							<Link to="##">
								<Text color="brand.red100" fontWeight="500">
									View details
								</Text>
							</Link>
						</Box>
					);
				},
			},
		],
		[]
	);

	const tableData = useMemo(
		() =>
			data &&
			data?.data?.claims?.map((item: IUserDataProps) => {
				return {
					date: moment(item.createdAt).format("Do MMM YYYY"),
					type: item.typeOfInsuranceClaim,
					typeOfIncident: item.typeOfIncident,
					status: item.status,
					action: item.id,
				};
			}),
		[data]
	);

	return (
		<Box>
			<TableComponent columns={columns} data={tableData} />
		</Box>
	);
};

export default Claims;
